import React, {  useState } from "react";
import styled from "styled-components";
import { useTolgee, useTranslate } from '@tolgee/react';

import { getFlag } from "../../Helpers/FlagHandler";
import { colors } from "../../Assets/styles/colors";

import { ReactComponent as Arrow } from "../../Assets/iconsv2/generic/forwardArrow.svg";
import LanguageListSelector from "../Auth Components/LanguageListSelector";
import LocalStorage from "../../Helpers/LocalStorage";
import { INTERFACE_TRANSLATION_LANGUAGES } from "../../Constants/constantValues";


const InterfaceLanguageSettings = () => {
  const { t } = useTranslate();
  const tolgee = useTolgee();
  const [interfaceLanguage, setInterfaceLanguage] = useState(tolgee.getLanguage());
  const [isLanguageSelectorOpen, setIsLanguageSelectorOpen] = useState(false);

  const displaySlectedLanguageFromList = (language) => {
    let found = INTERFACE_TRANSLATION_LANGUAGES.find((item) => item.locale === language);
    return found;
  };

  const openLanguageSelector = () => {
    setIsLanguageSelectorOpen(!isLanguageSelectorOpen);
  };


  return (
    <Container>
      {isLanguageSelectorOpen && (
        <LanguageListSelector
          isLanguageSelectorOpen={isLanguageSelectorOpen}
          openLanguageList={openLanguageSelector}
          valuesList={INTERFACE_TRANSLATION_LANGUAGES}
          setValue={(value) => {
            setInterfaceLanguage(value);
            tolgee.changeLanguage(value);
            LocalStorage.setInterfaceLanguage(value);
          }}
          selectedValue={interfaceLanguage}
          callLanguage
        />
      )}
      <Header>
        <HeaderTitle>{t('general.interface_language')}</HeaderTitle>
      </Header>

      <ContentWrapper>
        <Content>
          <Group>
            <GroupDescription>
              {t('settings.interface_language_description')}
            </GroupDescription>
            <GroupContentWrapper>
              <OptionWithPicker>
                <OptionWithPickerText>
                  {t('profile.language')}
                </OptionWithPickerText>
                <LanguageItem onClick={() => openLanguageSelector()}>
                  <Flag
                    src={getFlag(
                      displaySlectedLanguageFromList(interfaceLanguage)
                        .country_code
                    )}
                    alt={interfaceLanguage}
                  />{" "}
                  {displaySlectedLanguageFromList(interfaceLanguage).name} (
                  {displaySlectedLanguageFromList(interfaceLanguage).translation}
                  )
                  <Arrow style={{ marginLeft: "auto" }} />
                </LanguageItem>
              </OptionWithPicker>
            </GroupContentWrapper>
          </Group>
        </Content>
      </ContentWrapper>
    </Container>
  );
};

export default InterfaceLanguageSettings;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
`;
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 19px 16px;
  align-items: center;
  background: ${({ theme }) => theme.menu.background};
  border-bottom: 1px solid ${({ theme }) => theme.sidebar.borderColor};
  gap: 20px;
`;
const HeaderTitle = styled.h3`
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: 0.04px;
  color: ${({ theme }) => theme.menu.primaryTextColor};
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px;
  background: ${({ theme }) => theme.menu.background};
  height: 100%;
  overflow: auto;
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin: 0 auto;
  max-width: 631px;
  width: 100%;
  overflow: hidden;
`;

const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const GroupContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.menu.groupContentBackground};
  border-radius: 4px;
  overflow: hidden;
  padding: 8px 16px;
`;

const Flag = styled.img`
  width: 25px;
  height: 25px;
  border-radius: 100px;
  object-fit: cover;
`;

const GroupTitle = styled.p`
  padding-top: 10px;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.04px;
  vertical-align: middle;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
`;
const GroupDescription = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.04px;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
`;
const OptionWithPicker = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
  padding: 8px 0;
`;
const OptionWithPickerText = styled.p`
  min-width: 100px;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: -0.41px;
`;
const LanguageItem = styled.h3`
  display: flex;
  align-items: center;
  width: 100%;
  color: ${colors.listColor};
  color: ${({ selected, theme }) =>
    selected ? theme.menu.selectedTextColor : theme.menu.primaryTextColor};
  background: ${({ selected, theme }) =>
    selected
      ? theme.menu.selectedOpionBackground
      : theme.menu.groupContentBackground};
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  cursor: pointer;
  gap: 10px;
  border-bottom: 1px solid ${({ theme }) => theme.sidebar.borderColor};
  &:last-child {
    border: none;
  }
`;

const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  border: none;
  background: ${({ theme, selected }) =>
    selected ? theme.primaryButton.background : "none"};
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${({ theme, selected }) =>
    selected ? theme.primaryButton.color : theme.menu.secondaryTextColor};
  padding: 14px 16px;
  width: 100%;
  justify-content: center;
  min-width: 120px;
  cursor: pointer;
  svg {
    margin-left: auto;
    height: 20px;
    fill: transparent;
    color: transparent;
  }
`;
const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  border-radius: 4px;
  overflow: hidden;
  background: ${({ theme }) => theme.menu.groupContentBackground};
  width: 100%;
`;

const CheckedWrapper = styled.div`
  display: flex;
  svg {
    color: ${({ theme }) => theme.check.background};
    fill: ${({ theme }) => theme.check.checkSign};
  }
`;
const CheckEmptyWrapper = styled.div`
  display: flex;
  svg {
    color: ${({ theme }) => theme.check.border};
    stroke: ${({ theme }) => theme.check.checkSign};
  }
`;
